<template>
  <common-dialog @opened="onOpened" ref="dialog" :title="title" :modal="true" width="1350px" :in-dialog="inDialog">
    <!-- <div style="width:1000px;margin:auto;"> -->
      <div class="head">
        <div class="info">姓名：{{data.FullName}}</div>
        <div class="info">学生编号：{{data.StudentNumber}}</div>
        <div class="info">组合：{{data.SubjectGroup}}</div>
      </div>
      <div class="examSearch">
        <span style="margin-right:20px;">考试</span>
        <el-input v-model="ExamNames" size="mini" class="examInp" readonly @focus="onExamDialog(true)" placeholder="请选择考试"/>
      </div>
      <exam-chart ref="examChart" height="400px"></exam-chart>
      <el-table border :data="tableData" size="small" class="detailsTable">
        <el-table-column prop="title" label="考试名称" width="100" align="center"/>
        <template v-for="(item,index) in main">
          <el-table-column :key="item.ExamId" v-if="item.ExamCode!='数次平均'&&item.ExamCode!='年级平均'" :prop="'content'+index" :label="item.ExamCode" min-width="150" align="center">
          </el-table-column>
        </template>
      </el-table>
      <el-table border :data="main" size="small" class="detailsTable">
        <el-table-column prop="ExamCode" label="考试" width="100" align="center"/>
        <el-table-column prop="NewTotalScore" label="总分" align="center"/>
        <el-table-column prop="FourScore" label="四科分" align="center">
          <template slot-scope="{row}">
            <span v-if="row.FourScore==-1">缺考</span>
            <span v-else-if="row.FourScore==-2">-</span>
            <span v-else>{{row.FourScore}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="YwScore" label="语文" align="center">
          <template slot-scope="{row}">
            <span v-if="row.YwScore==-1">缺考</span>
            <span v-else-if="row.YwScore==-2">-</span>
            <span v-else>{{row.YwScore}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="SxScore" label="数学" align="center">
          <template slot-scope="{row}">
            <span v-if="row.SxScore==-1">缺考</span>
            <span v-else-if="row.SxScore==-2">-</span>
            <span v-else>{{row.SxScore}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="YyScore" label="英语" align="center">
          <template slot-scope="{row}">
            <span v-if="row.YyScore==-1">缺考</span>
            <span v-else-if="row.YyScore==-2">-</span>
            <span v-else>{{row.YyScore}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="WlScore" label="物理" align="center" min-width="85">
          <template slot-scope="{row}">
            <span v-if="row.WlScore==-1">缺考</span>
            <span v-else-if="row.WlScore==-2">非选修科目</span>
            <span v-else>{{row.WlScore}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="LsScore" label="历史" align="center" min-width="85">
          <template slot-scope="{row}">
            <span v-if="row.LsScore==-1">缺考</span>
            <span v-else-if="row.LsScore==-2">非选修科目</span>
            <span v-else>{{row.LsScore}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="HxScore" label="化学" align="center" min-width="85">
          <template slot-scope="{row}">
            <span v-if="row.HxScore==-1">缺考</span>
            <span v-else-if="row.HxScore==-2">非选修科目</span>
            <span v-else>{{row.HxScore}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="SwScore" label="生物" align="center" min-width="85">
          <template slot-scope="{row}">
            <span v-if="row.SwScore==-1">缺考</span>
            <span v-else-if="row.SwScore==-2">非选修科目</span>
            <span v-else>{{row.SwScore}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="ZzScore" label="政治" align="center" min-width="85">
          <template slot-scope="{row}">
            <span v-if="row.ZzScore==-1">缺考</span>
            <span v-else-if="row.ZzScore==-2">非选修科目</span>
            <span v-else>{{row.ZzScore}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="DlScore" label="地理" align="center" min-width="85">
          <template slot-scope="{row}">
            <span v-if="row.DlScore==-1">缺考</span>
            <span v-else-if="row.DlScore==-2">非选修科目</span>
            <span v-else>{{row.DlScore}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="Subject1Score" label="科目一" align="center" min-width="85">
          <template slot-scope="{row}">
            <span v-if="row.Subject1Score==-1">缺考</span>
            <span v-else-if="row.Subject1Score==-2">非选修科目</span>
            <span v-else>{{row.Subject1Score}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="Subject2Score" label="科目二" align="center" min-width="85">
          <template slot-scope="{row}">
            <span v-if="row.Subject2Score==-1">缺考</span>
            <span v-else-if="row.Subject2Score==-2">非选修科目</span>
            <span v-else>{{row.Subject2Score}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="Subject3Score" label="科目三" align="center" min-width="85">
          <template slot-scope="{row}">
            <span v-if="row.Subject3Score==-1">缺考</span>
            <span v-else-if="row.Subject3Score==-2">非选修科目</span>
            <span v-else>{{row.Subject3Score}}</span>
          </template>
        </el-table-column>
      </el-table>
    <!-- </div> -->
    <template slot="footer">
      <slot name="footer">
        <el-button type="primary" size="small" @click="close">关 闭</el-button>
      </slot>
    </template>
    <exam-dialog ref="examDialog" in-dialog selectable :multiple="true" :select-exam="ExamIds" @select-multiple="setExam"></exam-dialog>
  </common-dialog>
</template>
<script>
import commonDialog from "@/components/common/dialog";
import listDialogMixins from "@/mixins/listDialog";
import examChart from "@/components/dashboard/charts/examChart";
import examDialog from "@/components/achieve/exam/listDialog";

export default {
  components: { 
    commonDialog,
    examChart,
    examDialog
  },
  mixins: [listDialogMixins],
  props: {
    title: {
      type: String,
      default: "学生明细"
    },
  },
  data() {
    return {
      api: require("@/api/analyse/analyse").default,
      data: {},
      main: [],
      ExamNames: "",
      ExamIds: [],
      tableData: [],
      type: null
    }
  },
  methods:{
    onOpened(row){
      this.type = row.type;
      // console.log('row',row)
      this.data = row;
      this.ExamNames = "";
      this.ExamIds = [];
      this.getData({ StudentId: row.StudentId })
    },
    confirm(data) {
      this.query();
    },
    onExamDialog(type) {
      this.$refs.examDialog.open({}).then((that) => {
        that.getData({ SchoolYear: this.data.SchoolYear, ExamType: this.type, StudentId: this.data.StudentId }).then(() => {
          that.setSelected();
        })
      });
    },
    setExam(exam) {
      this.ExamNames = "";
      this.ExamIds = [];
      if(exam.length==0) {
        this.getData({ StudentId: this.data.StudentId })
        return
      }
      exam.forEach(e => {
        this.ExamIds.push(e.ExamId)
        this.ExamNames += e.ExamCode + '，';
      });
      this.getData({
        StudentId : this.data.StudentId,
        ExamIds: this.ExamIds
      })
    },
    getData(data) {
      this.loading(true);
      this.api.getStudentDetails(data).then(res => {
        if(res.Code == 0) {
          this.loading(false);
          let td = [
            { title: "强势科", },
            { title: "弱势科", },
            { title: "跟踪教师", },
          ]
          console.log("data",res.Data)
          res.Data.forEach((e,index) => {
            if(e.ExamCode !="数次平均") {
              // console.log('ee',e.StrongSubjects)
              td[0]['content'+index] = e.StrongSubjects;
              td[1]['content'+index] = e.WeakSubjects;
              td[2]['content'+index] = e.TeacherNames;
            }
          })
          this.main = res.Data;
          console.log("td",td)
          this.tableData = td;
          this.$refs.examChart.initChart(res.Data);
        }
      })
    }
  }
};
</script>
<style lang="scss" scoped>
.head{
  margin-bottom: 10px;
  .info{
    display: inline-block;
    margin-right: 40px;
  }
}
.examSearch{
  padding-top: 10px;
  margin-bottom: 20px;
}
.detailsTable{
  margin: 20px 0;
}
.examInp{
  width: calc(100% - 70px);
  /deep/ .el-input__inner{
    width: 100%;
  }
}
</style>